module.exports = __webpack_public_path__ + "static/media/search_device.be775057.png";